// modalComponents.js

import { ContainerReadProjectDetails } from "../../../../components/container/ContainerReadProjectDetails";
import { FomExtraResource } from "../../../../components/Form/project/FomExtraResource";
import { FormCalendar } from "../../../../components/Form/project/FormCalendar";
import { FormCancelProject } from "../../../../components/Form/project/FormCancelProject";
import { FormCliente } from "../../../../components/Form/project/FormCliente";
// import { FormConcluedProject } from "../../../../../components/Form/project/FormConcluedProject";
import { FormExtraTime } from "../../../../components/Form/project/FormExtraTime";
import { FormFinishProject } from "../../../../components/Form/project/FormFinishProject";
import { FormHoursProjectDetails } from "../../../../components/Form/project/FormHoursProjectDetails";
import { FormPauses } from "../../../../components/Form/project/FormPauses";
import { FormProjectDetails } from "../../../../components/Form/project/FormProjectDetails";
import { FormProjectRed } from "../../../../components/Form/project/FormProjectRed";
import { FormUpdateHours } from "../../../../components/Form/project/FormUpdateHours";
import { FormWorkTeam } from "../../../../components/Form/project/FormWorkTeam";
import { ModalCancelProject } from "../../../../components/Modal/ModalCancelProject";
import { ModalDebugTaskCount } from "../../../../components/Modal/ModalDebugTaskCount";
import { ModalUpdateTime } from "../../../../components/Modal/ModalUpdateTime";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";
import { FormConcludedComments } from "./FormConcludedComments";


const modalComponents = {
    [typeForDetailsProyect.hrsProjectDetails]: FormHoursProjectDetails,
    [typeForDetailsProyect.client]: FormCliente,
    [typeForDetailsProyect.hrsExtraResource]: FomExtraResource,
    [typeForDetailsProyect.hrsExtraTime]: FormExtraTime,
    [typeForDetailsProyect.updateHrs]: FormUpdateHours,
    [typeForDetailsProyect.calendar]: FormCalendar,
    [typeForDetailsProyect.pauses]: FormPauses,
    [typeForDetailsProyect.finishProjectDate]: FormFinishProject,
    [typeForDetailsProyect.concluedProject]: FormConcludedComments,
    [typeForDetailsProyect.projectRed]: FormProjectRed,
    [typeForDetailsProyect.viewConcluedProject]: ContainerReadProjectDetails,
    [typeForDetailsProyect.updateTimeConclued]: ModalUpdateTime,
    [typeForDetailsProyect.cancelarProyect]: ModalCancelProject,
    [typeForDetailsProyect.continueCancelarProyect]: FormCancelProject,
    [typeForDetailsProyect.workTeam]: FormWorkTeam,
    [typeForDetailsProyect.projects]: FormProjectDetails,
    [typeForDetailsProyect.modalDebugTaskCount]: ModalDebugTaskCount,
};

export default modalComponents;
